import styled from 'styled-components';

export const ResourcesWrapper = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 12px 0 rgba(25,51,77,0.06);
`;

export const ResourcesTitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 700;
  color: #223046;
  margin: 4px 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeroImage = styled.div`
  height: 220px;
  border-radius: 10px;
  background: url('/src/assets/library.jpeg') center/cover no-repeat;
  margin-bottom: 12px;
  display: flex;
  align-items: flex-end;
  color: #fff;
  padding: 14px;
`;

export const HeroCaption = styled.div`
  backdrop-filter: blur(2px);
  background: rgba(0,0,0,0.35);
  padding: 8px 10px;
  border-radius: 8px;
`;

export const Action = styled.div`
  background: #F8FAFC;
  border: 1.5px solid #E7EAEE;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ActionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
`;

export const Occupancy = styled.div`
  margin-top: 10px;
  font-size: 0.95rem;
  color: #6B7280;
`;


